import type { InfoTopicId } from '../components/InfoMenuModal';

export interface RouteDefinition {
  path: string;
  canonicalPath: string;
  title: string;
  metaDescription: string;
  tabKey: string;
  infoTopic?: InfoTopicId;
  category: 'Principal' | 'Serviços' | 'Loja' | 'Blog' | 'Ferramentas' | 'Guias' | 'Institucional' | 'Cliente' | 'Administrador';
  navLabel: string;
  badge?: string;
}

export const SITE_DOMAIN = 'https://dojapao.co.jp';

export const ROUTES: Record<string, RouteDefinition> = {
  '/': {
    path: '/',
    canonicalPath: '/',
    title: 'Do Japão | Redirecionamento de Encomendas, Mercari JP e Leilões Yahoo Japan',
    metaDescription: 'Sua Suíte Exclusiva no Japão com 30 dias grátis de armazenamento. Compre no Mercari, Yahoo Auctions, Amazon JP e receba com segurança no Brasil.',
    tabKey: 'landing',
    category: 'Principal',
    navLabel: 'Início'
  },
  '/blog': {
    path: '/blog',
    canonicalPath: '/blog/',
    title: 'Blog & Guias de Importação do Japão | Do Japão',
    metaDescription: 'Artigos, tutoriais de compras no Mercari Japan, leilões do Yahoo Japan e comparativo de fretes internacionais.',
    tabKey: 'blog',
    category: 'Blog',
    navLabel: 'Blog & Guias',
    badge: 'Artigos'
  },
  '/videos': {
    path: '/videos',
    canonicalPath: '/videos/',
    title: 'Vídeos Explicativos & Tutoriais Passo a Passo | Do Japão',
    metaDescription: 'Assista aos vídeos explicativos sobre como se cadastrar, como comprar no Japão, como consolidar sua caixa e economizar no frete internacional.',
    tabKey: 'videos',
    category: 'Guias',
    navLabel: 'Vídeos Explicativos',
    badge: 'Tutoriais'
  },
  '/tutoriais': {
    path: '/tutoriais',
    canonicalPath: '/videos/',
    title: 'Vídeos Explicativos & Tutoriais Passo a Passo | Do Japão',
    metaDescription: 'Assista aos vídeos explicativos sobre como se cadastrar, como comprar no Japão, como consolidar sua caixa e economizar no frete internacional.',
    tabKey: 'videos',
    category: 'Guias',
    navLabel: 'Tutoriais em Vídeo',
    badge: 'Vídeos'
  },
  '/personal-shopper': {
    path: '/personal-shopper',
    canonicalPath: '/personal-shopper/',
    title: 'Personal Shopper no Japão (Compra Assistida) | Do Japão',
    metaDescription: 'Compramos para você em qualquer site ou loja física do Japão. Suporte para Mercari, Yahoo Auctions, Surugaya e lojas de Akihabara.',
    tabKey: 'personal-shopper',
    category: 'Serviços',
    navLabel: 'Personal Shopper',
    badge: 'Compra Assistida'
  },
  '/loja': {
    path: '/loja',
    canonicalPath: '/loja/',
    title: 'Loja Oficial Do Japão | Colecionáveis, Figures e Pronta Entrega em Saitama',
    metaDescription: 'Action figures originais Bandai, games retro, colecionáveis e produtos com pronta entrega e envio imediato direto do armazém da Do Japão.',
    tabKey: 'nossa-loja',
    category: 'Loja',
    navLabel: 'Loja Do Japão',
    badge: 'Pronta Entrega'
  },
  '/nossa-loja': {
    path: '/nossa-loja',
    canonicalPath: '/loja/',
    title: 'Loja Oficial Do Japão | Colecionáveis, Figures e Pronta Entrega em Saitama',
    metaDescription: 'Action figures originais Bandai, games retro, colecionáveis e produtos com pronta entrega e envio imediato direto do armazém da Do Japão.',
    tabKey: 'nossa-loja',
    category: 'Loja',
    navLabel: 'Nossa Loja'
  },
  '/servicos-e-precos': {
    path: '/servicos-e-precos',
    canonicalPath: '/servicos-e-precos/',
    title: 'Serviços e Preços de Redirecionamento 2026 | Do Japão',
    metaDescription: 'Tabela transparente de tarifas: 30 dias de armazenamento gratuito, consolidação inteligente, fotos HD e serviços especiais.',
    tabKey: 'info',
    infoTopic: 'servicos-precos',
    category: 'Serviços',
    navLabel: 'Serviços & Preços',
    badge: 'Tarifas 2026'
  },
  '/servicos': {
    path: '/servicos',
    canonicalPath: '/servicos-e-precos/',
    title: 'Serviços e Preços de Redirecionamento 2026 | Do Japão',
    metaDescription: 'Tabela transparente de tarifas: 30 dias de armazenamento gratuito, consolidação inteligente, fotos HD e serviços especiais.',
    tabKey: 'info',
    infoTopic: 'servicos-precos',
    category: 'Serviços',
    navLabel: 'Serviços'
  },
  '/calculadora-frete': {
    path: '/calculadora-frete',
    canonicalPath: '/calculadora-frete/',
    title: 'Calculadora de Frete Internacional Japão x Brasil | Do Japão',
    metaDescription: 'Simule o custo do frete internacional do Japão para o Brasil em ienes (JPY) e reais (BRL). Japan Post EMS, Small Packet e Marítimo.',
    tabKey: 'calculator',
    category: 'Ferramentas',
    navLabel: 'Calculadora Frete',
    badge: 'Simulador'
  },
  '/simulador-de-impostos': {
    path: '/simulador-de-impostos',
    canonicalPath: '/simulador-de-impostos/',
    title: 'Simulador Oficial de Impostos no Brasil (II + ICMS) | Do Japão',
    metaDescription: 'Simule o Imposto de Importação e ICMS por dentro pela Lei 14.902/2024. Escolha o frete internacional por dropdown com Japan Post, FedEx, DHL e UPS.',
    tabKey: 'calculator',
    category: 'Ferramentas',
    navLabel: 'Simulador de Impostos',
    badge: 'Lei 14.902/2024'
  },
  '/simulador-impostos': {
    path: '/simulador-impostos',
    canonicalPath: '/simulador-de-impostos/',
    title: 'Simulador Oficial de Impostos no Brasil (II + ICMS) | Do Japão',
    metaDescription: 'Simule o Imposto de Importação e ICMS por dentro pela Lei 14.902/2024. Escolha o frete internacional por dropdown com Japan Post, FedEx, DHL e UPS.',
    tabKey: 'calculator',
    category: 'Ferramentas',
    navLabel: 'Simulador de Impostos',
    badge: 'Lei 14.902/2024'
  },
  '/sobre': {
    path: '/sobre',
    canonicalPath: '/sobre/',
    title: 'Sobre a Do Japão | Infraestrutura & Armazém em Saitama, Japão',
    metaDescription: 'Conheça a equipe brasileira residente no Japão com armazém próprio em Saitama (região de Tóquio), oferecendo logística segura e suporte em português.',
    tabKey: 'info',
    infoTopic: 'quem-somos',
    category: 'Institucional',
    navLabel: 'Sobre Nós'
  },
  '/como-funciona': {
    path: '/como-funciona',
    canonicalPath: '/como-funciona/',
    title: 'Como Funciona o Redirecionamento de Compras do Japão | Do Japão',
    metaDescription: 'Passo a passo simples: crie sua Suíte, compre em qualquer loja do Japão, junte seus pacotes e receba na sua casa no Brasil.',
    tabKey: 'landing',
    category: 'Institucional',
    navLabel: 'Como Funciona'
  },
  '/tabela-de-tamanhos': {
    path: '/tabela-de-tamanhos',
    canonicalPath: '/tabela-de-tamanhos/',
    title: 'Tabela de Tamanhos Japão x Brasil (Roupas & Calçados) | Do Japão',
    metaDescription: 'Tabela oficial de conversão de tamanhos de roupas, calçados e medidas corporais japonesas para o padrão brasileiro.',
    tabKey: 'info',
    infoTopic: 'tabela-tamanhos',
    category: 'Guias',
    navLabel: 'Tabela de Tamanhos',
    badge: 'Roupas & Calçados'
  },
  '/impostos-de-compra-e-importacao': {
    path: '/impostos-de-compra-e-importacao',
    canonicalPath: '/impostos-de-compra-e-importacao/',
    title: 'Impostos de Compra e Importação Alfandegária do Japão | Do Japão',
    metaDescription: 'Entenda como funciona a tributação aduaneira brasileira, ICMS, Remessa Conforme e orientações para desembaraço rápido.',
    tabKey: 'info',
    infoTopic: 'impostos-importacao',
    category: 'Guias',
    navLabel: 'Impostos de Importação',
    badge: 'Alfandegário'
  },
  '/produtos-proibidos-ou-perigosos': {
    path: '/produtos-proibidos-ou-perigosos',
    canonicalPath: '/produtos-proibidos-ou-perigosos/',
    title: 'Produtos Proibidos ou Perigosos para Envio do Japão | Do Japão',
    metaDescription: 'Consulte a lista completa de mercadorias proibidas ou restritas para envio aéreo internacional pelo Japan Post e alfândega do Brasil.',
    tabKey: 'info',
    infoTopic: 'produtos-proibidos',
    category: 'Guias',
    navLabel: 'Produtos Proibidos',
    badge: 'Atenção'
  },
  '/mercari': {
    path: '/mercari',
    canonicalPath: '/mercari/',
    title: 'Como Comprar no Mercari Japan e Enviar para o Brasil | Do Japão',
    metaDescription: 'Tutorial passo a passo para comprar no maior marketplace do Japão com economia de até 80% e suporte da nossa equipe.',
    tabKey: 'info',
    infoTopic: 'como-comprar-mercari',
    category: 'Guias',
    navLabel: 'Mercari Japan',
    badge: 'Tutorial'
  },
  '/leilao-yahoo-japan': {
    path: '/leilao-yahoo-japan',
    canonicalPath: '/leilao-yahoo-japan/',
    title: 'Como Dar Lances no Yahoo! Auctions Japan (Yafuoku) | Do Japão',
    metaDescription: 'Guia completo para arrematar raridades, figures raros, games retro e colecionáveis no maior leilão online do Japão.',
    tabKey: 'info',
    infoTopic: 'como-dar-lances-yahoo',
    category: 'Guias',
    navLabel: 'Leilões Yahoo Japan',
    badge: 'Lances'
  },
  '/planos': {
    path: '/planos',
    canonicalPath: '/planos/',
    title: 'Planos VIP & Assinaturas de Importação | Do Japão',
    metaDescription: 'Conheça nossos Planos VIP com armazenamento estendido de até 60 dias, consolidação gratuita e atendimento prioritário.',
    tabKey: 'subscription-plans',
    category: 'Serviços',
    navLabel: 'Planos VIP',
    badge: 'VIP'
  },
  '/afiliados': {
    path: '/afiliados',
    canonicalPath: '/afiliados/',
    title: 'Programa de Afiliados & Indique e Ganhe por Suíte | Do Japão',
    metaDescription: 'Indique amigos com o código da sua Suíte DJ-XXXX e ganhe créditos de frete internacional em ienes ou comissões via PIX.',
    tabKey: 'affiliates',
    category: 'Serviços',
    navLabel: 'Programa de Afiliados',
    badge: 'Indique & Ganhe'
  },
  '/indique-e-ganhe': {
    path: '/indique-e-ganhe',
    canonicalPath: '/afiliados/',
    title: 'Programa de Afiliados & Indique e Ganhe por Suíte | Do Japão',
    metaDescription: 'Indique amigos com o código da sua Suíte DJ-XXXX e ganhe créditos de frete internacional em ienes ou comissões via PIX.',
    tabKey: 'affiliates',
    category: 'Serviços',
    navLabel: 'Indique e Ganhe',
    badge: 'Créditos'
  },
  '/sorteios': {
    path: '/sorteios',
    canonicalPath: '/sorteios/',
    title: 'Sorteios Oficiais de Brindes para Suítes no Japão | Do Japão',
    metaDescription: 'Participe dos sorteios mensais de brindes japoneses exclusivos para clientes com Suíte ativa na Do Japão.',
    tabKey: 'giveaways',
    category: 'Serviços',
    navLabel: 'Sorteios de Brindes',
    badge: 'Brindes na Suíte'
  },
  '/rastreamento': {
    path: '/rastreamento',
    canonicalPath: '/rastreamento/',
    title: 'Rastreamento de Encomendas Internacionais do Japão | Do Japão',
    metaDescription: 'Acompanhe em tempo real os pacotes e consolidações despachadas do armazém de Saitama até o endereço de entrega no Brasil.',
    tabKey: 'tracking',
    category: 'Ferramentas',
    navLabel: 'Rastreamento',
    badge: 'Japan Post'
  },
  '/contato': {
    path: '/contato',
    canonicalPath: '/contato/',
    title: 'Fale Conosco & Central de Suporte | Do Japão',
    metaDescription: 'Atendimento humanizado 100% em português via WhatsApp, tickets e e-mail com a equipe residente no Japão.',
    tabKey: 'support',
    category: 'Institucional',
    navLabel: 'Atendimento & Suporte'
  },
  '/faq': {
    path: '/faq',
    canonicalPath: '/faq/',
    title: 'Perguntas Frequentes (FAQ) sobre Redirecionamento do Japão | Do Japão',
    metaDescription: 'Respostas para dúvidas comuns sobre endereço japonês, consolidação, PIX, taxas aduaneiras e prazos de entrega.',
    tabKey: 'info',
    infoTopic: 'faq',
    category: 'Institucional',
    navLabel: 'Dúvidas Frequentes'
  },
  '/trocas-e-devolucoes': {
    path: '/trocas-e-devolucoes',
    canonicalPath: '/trocas-e-devolucoes/',
    title: 'Política de Trocas e Devoluções | Do Japão',
    metaDescription: 'Consulte a política de trocas, devoluções e conferência de mercadorias no armazém da Do Japão em Saitama.',
    tabKey: 'info',
    infoTopic: 'trocas-devolucoes',
    category: 'Institucional',
    navLabel: 'Trocas e Devoluções'
  },
  '/formas-de-pagamento': {
    path: '/formas-de-pagamento',
    canonicalPath: '/formas-de-pagamento/',
    title: 'Formas de Pagamento Aceitas (PIX, Cartão, Wise) | Do Japão',
    metaDescription: 'Pague suas compras e fretes com PIX imediato, cartões de crédito parcelados, Wise ou transferências internacionais.',
    tabKey: 'info',
    infoTopic: 'formas-pagamento',
    category: 'Guias',
    navLabel: 'Formas de Pagamento'
  },
  '/sites-de-compras': {
    path: '/sites-de-compras',
    canonicalPath: '/sites-de-compras/',
    title: 'Guia de Melhores Sites de Compras no Japão | Do Japão',
    metaDescription: 'Lista dos principais sites e marketplaces recomendados no Japão para comprar figures, animes, jogos, roupas e eletrônicos.',
    tabKey: 'info',
    infoTopic: 'sites-compras-japao',
    category: 'Guias',
    navLabel: 'Lojas no Japão'
  },
  '/painel': {
    path: '/painel',
    canonicalPath: '/',
    title: 'Minha Suíte & Painel do Cliente | Do Japão',
    metaDescription: 'Acesse o painel da sua Suíte no Japão, veja pacotes recebidos, fotos de conferência e solicite consolidação de caixas.',
    tabKey: 'dashboard',
    category: 'Cliente',
    navLabel: 'Minha Suíte'
  },
  '/admin': {
    path: '/admin',
    canonicalPath: '/admin/',
    title: 'Painel do Administrador WordPress | Do Japão',
    metaDescription: 'Painel administrativo oficial estilo WordPress para gestão de encomendas no armazém de Saitama, consolidações, clientes e loja.',
    tabKey: 'admin-wordpress',
    category: 'Administrador',
    navLabel: 'Painel WordPress',
    badge: 'WP Admin'
  },
  '/wp-admin': {
    path: '/wp-admin',
    canonicalPath: '/admin/',
    title: 'Painel do Administrador WordPress | Do Japão',
    metaDescription: 'Painel administrativo oficial estilo WordPress para gestão de encomendas no armazém de Saitama, consolidações, clientes e loja.',
    tabKey: 'admin-wordpress',
    category: 'Administrador',
    navLabel: 'Painel WordPress',
    badge: 'WP Admin'
  }
};

/**
 * Generates an SEO-friendly URL slug strictly based on a title string.
 * Strips accents, punctuation, non-alphanumeric chars, and joins words with single hyphens.
 *
 * Example:
 * "Figure Bandai Ichiban Kuji One Piece Luffy Gear 5 (Masterlise)"
 * -> "figure-bandai-ichiban-kuji-one-piece-luffy-gear-5-masterlise"
 *
 * "Como Comprar no Mercari Japan e Enviar para o Brasil!"
 * -> "como-comprar-no-mercari-japan-e-enviar-para-o-brasil"
 */
export function generateSlug(text: string): string {
  if (!text) return '';
  return text
    .toString()
    .normalize('NFD') // Separate accented characters from diacritics
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove invalid chars, punctuation, symbols, emojis
    .replace(/[\s_]+/g, '-') // Replace whitespace and underscores with a hyphen
    .replace(/-+/g, '-') // Collapse multiple hyphens
    .replace(/^-+|-+$/g, ''); // Trim hyphens from ends
}

/**
 * Returns the canonical slug for a product strictly based on its title.
 */
export function getProductSlug(product: { title?: string; slug?: string; id?: string }): string {
  if (!product) return '';
  if (product.title) {
    const fromTitle = generateSlug(product.title);
    if (fromTitle) return fromTitle;
  }
  if (product.slug) return generateSlug(product.slug);
  return product.id || '';
}

/**
 * Returns the canonical slug for a blog post strictly based on its title.
 */
export function getBlogPostSlug(post: { title?: string; slug?: string; id?: string }): string {
  if (!post) return '';
  if (post.title) {
    const fromTitle = generateSlug(post.title);
    if (fromTitle) return fromTitle;
  }
  if (post.slug) return generateSlug(post.slug);
  return post.id || '';
}

/**
 * Strips search query parameters, hash fragments, and duplicate slashes,
 * returning a pristine, authoritative canonical URL.
 * 
 * Examples:
 * - "/loja?s=naruto&cat=figures#topo" -> "https://dojapao.co.jp/loja/"
 * - "/blog?busca=frete&p=2" -> "https://dojapao.co.jp/blog/"
 * - "/produto/dragon-ball-z/?ref=123" -> "https://dojapao.co.jp/produto/dragon-ball-z/"
 * - "/" -> "https://dojapao.co.jp/"
 */
export function getCleanCanonicalUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return `${SITE_DOMAIN}/`;

  // 1. Separate path from query parameters (?...) and hash fragments (#...)
  let rawPath = pathOrUrl.split('?')[0].split('#')[0].trim();

  // 2. If an absolute URL was passed, extract only the pathname
  if (rawPath.startsWith('http://') || rawPath.startsWith('https://')) {
    try {
      const parsed = new URL(rawPath);
      rawPath = parsed.pathname;
    } catch {
      rawPath = rawPath.replace(/^https?:\/\/[^/]+/, '');
    }
  }

  // 3. Normalize multiple slashes and ensure single leading slash
  let clean = rawPath.replace(/\/+/g, '/');
  if (!clean.startsWith('/')) {
    clean = `/${clean}`;
  }

  // 4. Root path handling
  if (clean === '/') {
    return `${SITE_DOMAIN}/`;
  }

  // 5. Ensure directory trailing slash for consistent SEO indexing
  const hasFileExtension = /\.[a-zA-Z0-9]+$/.test(clean);
  if (!hasFileExtension && !clean.endsWith('/')) {
    clean = `${clean}/`;
  }

  return `${SITE_DOMAIN}${clean}`;
}

export interface SeoUpdateOptions {
  isSearchOrFilter?: boolean;
  image?: string;
  type?: 'website' | 'article' | 'product';
}

/**
 * Updates DOM SEO metadata (title, description, canonical link, open graph, twitter cards, robots)
 * Ensures that the canonical tag is strictly clean without search parameters to prevent duplicate URLs.
 */
export function updateSeoMeta(
  title: string,
  description: string,
  canonicalPathOrUrl: string,
  options?: SeoUpdateOptions
) {
  if (typeof document === 'undefined') return;

  // 1. Document Title
  document.title = title;

  // 2. Meta Title
  let titleMeta = document.querySelector('meta[name="title"]');
  if (!titleMeta) {
    titleMeta = document.createElement('meta');
    titleMeta.setAttribute('name', 'title');
    document.head.appendChild(titleMeta);
  }
  titleMeta.setAttribute('content', title);

  // 3. Meta Description
  let descMeta = document.querySelector('meta[name="description"]');
  if (!descMeta) {
    descMeta = document.createElement('meta');
    descMeta.setAttribute('name', 'description');
    document.head.appendChild(descMeta);
  }
  descMeta.setAttribute('content', description);

  // 4. OpenGraph Title & Description
  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) ogTitle.setAttribute('content', title);

  let ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc) ogDesc.setAttribute('content', description);

  // 5. Twitter Card Title & Description
  let twTitle = document.querySelector('meta[name="twitter:title"]');
  if (twTitle) twTitle.setAttribute('content', title);

  let twDesc = document.querySelector('meta[name="twitter:description"]');
  if (twDesc) twDesc.setAttribute('content', description);

  // 6. Optional Image
  if (options?.image) {
    let ogImg = document.querySelector('meta[property="og:image"]');
    if (ogImg) ogImg.setAttribute('content', options.image);
    let twImg = document.querySelector('meta[name="twitter:image"]');
    if (twImg) twImg.setAttribute('content', options.image);
  }

  // 7. Canonical Tag (Guaranteed to be 100% parameter-free, avoiding duplicate URLs)
  const finalCanonical = getCleanCanonicalUrl(canonicalPathOrUrl);

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('id', 'canonical-url');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', finalCanonical);

  // 8. OpenGraph URL & Twitter URL (Synced with authoritative canonical URL)
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) ogUrl.setAttribute('content', finalCanonical);

  let twUrl = document.querySelector('meta[name="twitter:url"]');
  if (twUrl) twUrl.setAttribute('content', finalCanonical);

  // 9. Robots Meta Tag (Protects crawl budget & prevents indexing thin duplicate search results)
  let robotsMeta = document.querySelector('meta[name="robots"]');
  if (!robotsMeta) {
    robotsMeta = document.createElement('meta');
    robotsMeta.setAttribute('name', 'robots');
    document.head.appendChild(robotsMeta);
  }

  if (options?.isSearchOrFilter) {
    // Tell search engines not to index this parameterized variation, but continue following internal product/blog links
    robotsMeta.setAttribute('content', 'noindex, follow');
  } else {
    // Full standard indexing for canonical pages
    robotsMeta.setAttribute('content', 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1');
  }
}

export function getPathForTopic(topicId: InfoTopicId): string {
  switch (topicId) {
    case 'servicos-precos': return '/servicos-e-precos';
    case 'calculadora-frete': return '/calculadora-frete';
    case 'blog-guias': return '/blog';
    case 'conversor-moedas': return '/calculadora-frete';
    case 'tabela-tamanhos': return '/tabela-de-tamanhos';
    case 'como-comprar-mercari': return '/mercari';
    case 'como-dar-lances-yahoo': return '/leilao-yahoo-japan';
    case 'impostos-importacao': return '/impostos-de-compra-e-importacao';
    case 'produtos-proibidos': return '/produtos-proibidos-ou-perigosos';
    case 'quem-somos': return '/sobre';
    case 'formas-pagamento': return '/formas-de-pagamento';
    case 'sites-compras-japao': return '/sites-de-compras';
    case 'faq': return '/faq';
    case 'trocas-devolucoes': return '/trocas-e-devolucoes';
    case 'salvar-app-celular': return '/';
    default: return '/servicos-e-precos';
  }
}

export interface ResolvedRoute {
  path: string;
  tabKey: string;
  infoTopic?: InfoTopicId;
  productId?: string;
  postId?: string;
  scrollToId?: string;
  title: string;
  description: string;
  canonicalPath: string;
  isSearchOrFilter?: boolean;
  searchTerm?: string;
}

/**
 * Resolves any browser pathname and search parameters into route state,
 * separating search/filter parameters from the authoritative canonical path.
 */
export function resolveCurrentRoute(pathInput?: string): ResolvedRoute {
  let fullInput = pathInput;
  if (!fullInput && typeof window !== 'undefined') {
    fullInput = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  }
  if (!fullInput) fullInput = '/';

  // 1. Separate path from query string & hash
  const [pathPart, queryPart] = fullInput.split('?');
  const pathOnly = (pathPart || '/').split('#')[0];
  const cleanPath = pathOnly.replace(/\/+$/, '') || '/';

  // 2. Parse search parameters
  let searchParams: URLSearchParams;
  if (queryPart !== undefined) {
    searchParams = new URLSearchParams(queryPart.split('#')[0]);
  } else if (typeof window !== 'undefined') {
    searchParams = new URLSearchParams(window.location.search);
  } else {
    searchParams = new URLSearchParams('');
  }

  const rawSearchTerm =
    searchParams.get('s') ||
    searchParams.get('q') ||
    searchParams.get('busca') ||
    searchParams.get('search') ||
    searchParams.get('termo') ||
    '';

  const isSearchOrFilter = Boolean(
    rawSearchTerm ||
    searchParams.get('categoria') ||
    searchParams.get('category') ||
    searchParams.get('tag') ||
    searchParams.get('filtro') ||
    searchParams.get('order') ||
    searchParams.get('sort') ||
    searchParams.get('page') ||
    searchParams.get('p') ||
    searchParams.get('utm_source')
  );

  // 3. Legacy query parameter support (e.g. ?produto=slug or ?post=slug)
  const queryProduto = searchParams.get('produto');
  const queryPost = searchParams.get('post');

  if (queryProduto) {
    const readable = queryProduto.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    return {
      path: `/produto/${queryProduto}`,
      tabKey: 'nossa-loja',
      productId: queryProduto,
      title: `${readable} | Loja Do Japão`,
      description: `Compre ${readable} direto do Japão com envio para o Brasil, fotos HD e armazenamento em Saitama.`,
      canonicalPath: `/produto/${queryProduto}/`,
      isSearchOrFilter: false
    };
  }

  if (queryPost) {
    const readable = queryPost.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    return {
      path: `/blog/${queryPost}`,
      tabKey: 'blog',
      postId: queryPost,
      title: `${readable} | Blog Do Japão`,
      description: `Confira o artigo ${readable} no blog da Do Japão com dicas exclusivas de importação e compras no Japão.`,
      canonicalPath: `/blog/${queryPost}/`,
      isSearchOrFilter: false
    };
  }

  // 4. Dedicated WordPress Admin routes
  if (cleanPath === '/admin' || cleanPath === '/wp-admin') {
    return {
      path: cleanPath,
      tabKey: 'admin-wordpress',
      title: 'Painel do Administrador WordPress | Do Japão',
      description: 'Painel administrativo oficial estilo WordPress para gestão de encomendas no armazém de Saitama, consolidações, clientes e loja.',
      canonicalPath: '/admin/',
      isSearchOrFilter: false
    };
  }

  // 5. Direct product path: /produto/:slug or /loja/:slug
  if (cleanPath.startsWith('/produto/') || (cleanPath.startsWith('/loja/') && cleanPath.length > 6)) {
    const rawSlug = cleanPath.replace(/^\/(produto|loja)\//, '').replace(/\/+$/, '');
    const slug = generateSlug(rawSlug);
    const readable = rawSlug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    return {
      path: cleanPath,
      tabKey: 'nossa-loja',
      productId: slug,
      title: `${readable} | Loja Do Japão`,
      description: `Compre ${readable} direto do Japão com envio para o Brasil, fotos HD e armazenamento em Saitama.`,
      canonicalPath: `/produto/${slug}/`,
      isSearchOrFilter
    };
  }

  // 6. Direct blog post: /blog/:slug or specific legacy articles
  if (cleanPath.startsWith('/blog/') && cleanPath.length > 6) {
    const rawSlug = cleanPath.substring(6).replace(/\/+$/, '');
    const slug = generateSlug(rawSlug);
    const readable = rawSlug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    return {
      path: cleanPath,
      tabKey: 'blog',
      postId: slug,
      title: `${readable} | Blog Do Japão`,
      description: `Confira o artigo ${readable} no blog da Do Japão com dicas exclusivas de importação e compras no Japão.`,
      canonicalPath: `/blog/${slug}/`,
      isSearchOrFilter
    };
  }

  // Legacy blog posts without /blog/ prefix
  const legacyBlogPosts: Record<string, string> = {
    '/como-importar-do-japao-e-economizar-ate-80': 'Como Importar do Japão e Economizar até 80%',
    '/como-calcular-a-margem-de-lucro-de-um-produto-importado': 'Como Calcular a Margem de Lucro na Revenda de Importados',
    '/transferencia-via-western-union': 'Transferências e Pagamentos Internacionais via Western Union',
    '/agende-sua-consultoria': 'Agende sua Consultoria de Importação do Japão',
    '/affiliate-tos-page': 'Termos do Programa de Afiliados',
    '/affiliate-tos-page-2-2': 'Regulamento de Afiliados e Comissões',
    '/37749-2': 'Guia Oficial de Redirecionamento do Japão'
  };

  if (legacyBlogPosts[cleanPath]) {
    const title = legacyBlogPosts[cleanPath];
    return {
      path: cleanPath,
      tabKey: 'blog',
      postId: cleanPath.replace(/^\//, ''),
      title: `${title} | Do Japão`,
      description: `Aprenda tudo sobre compras no Japão: ${title}. Guia completo oficial da Do Japão.`,
      canonicalPath: `${cleanPath}/`,
      isSearchOrFilter
    };
  }

  // 7. Exact match in ROUTES
  if (ROUTES[cleanPath]) {
    const r = ROUTES[cleanPath];
    const pageTitle = rawSearchTerm
      ? `Busca: "${rawSearchTerm}" | ${r.navLabel} | Do Japão`
      : r.title;
    return {
      path: cleanPath,
      tabKey: r.tabKey,
      infoTopic: r.infoTopic,
      title: pageTitle,
      description: r.metaDescription,
      canonicalPath: r.canonicalPath,
      scrollToId: cleanPath === '/como-funciona' ? 'como-funciona' : undefined,
      isSearchOrFilter,
      searchTerm: rawSearchTerm
    };
  }

  // 8. Fallback for /category/promo, /product-category/..., /product-tag/...
  if (
    cleanPath.startsWith('/category/') ||
    cleanPath.startsWith('/product-category/') ||
    cleanPath.startsWith('/product-tag/') ||
    cleanPath.startsWith('/wp/categoria-')
  ) {
    return {
      path: cleanPath,
      tabKey: 'nossa-loja',
      title: 'Produtos & Colecionáveis no Japão | Loja Do Japão',
      description: 'Catálogo de figures, games e produtos exclusivos prontos para envio no armazém de Saitama.',
      canonicalPath: '/loja/',
      isSearchOrFilter: true
    };
  }

  // 9. Default root landing page
  const homeRoute = ROUTES['/'];
  return {
    path: '/',
    tabKey: homeRoute.tabKey,
    title: rawSearchTerm ? `Busca: "${rawSearchTerm}" | Do Japão` : homeRoute.title,
    description: homeRoute.metaDescription,
    canonicalPath: homeRoute.canonicalPath,
    isSearchOrFilter,
    searchTerm: rawSearchTerm
  };
}

/**
 * Main application navigation function: updates URL bar, document meta,
 * and notifies listeners without full page reloads.
 * Strips search parameters from canonical tags and asserts clean URL.
 */
export function navigateTo(
  targetPath: string,
  options?: {
    replace?: boolean;
    infoTopic?: InfoTopicId;
    productId?: string;
    postId?: string;
    scrollToTop?: boolean;
    sectionId?: string;
    isSearchOrFilter?: boolean;
  }
) {
  if (typeof window === 'undefined') return;

  const currentPath = `${window.location.pathname}${window.location.search}`;
  const isTargetSame = currentPath === targetPath && !options?.infoTopic && !options?.productId && !options?.postId;

  const resolved = resolveCurrentRoute(targetPath);
  const finalTitle = resolved.title;
  const finalDescription = resolved.description;
  const finalCanonical = resolved.canonicalPath;
  const isSearchOrFilter = options?.isSearchOrFilter !== undefined ? options.isSearchOrFilter : resolved.isSearchOrFilter;

  if (options?.replace) {
    window.history.replaceState({ path: targetPath }, finalTitle, targetPath);
  } else if (!isTargetSame) {
    window.history.pushState({ path: targetPath }, finalTitle, targetPath);
  }

  updateSeoMeta(finalTitle, finalDescription, finalCanonical, { isSearchOrFilter });

  const eventDetail = {
    path: targetPath,
    tabKey: resolved.tabKey,
    infoTopic: options?.infoTopic || resolved.infoTopic,
    productId: options?.productId || resolved.productId,
    postId: options?.postId || resolved.postId,
    sectionId: options?.sectionId || resolved.scrollToId,
    isSearchOrFilter
  };

  window.dispatchEvent(new CustomEvent('dojapao:navigate', { detail: eventDetail }));

  if (options?.sectionId || resolved.scrollToId) {
    setTimeout(() => {
      const el = document.getElementById(options?.sectionId || resolved.scrollToId!);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }, 120);
  } else if (options?.scrollToTop !== false) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

export function getPathForTab(tabKey: string, sectionId?: string, infoTopic?: InfoTopicId): string {
  switch (tabKey) {
    case 'blog': return '/blog';
    case 'videos': return '/videos';
    case 'affiliates': return '/afiliados';
    case 'giveaways': return '/sorteios';
    case 'personal-shopper': return '/personal-shopper';
    case 'nossa-loja': return '/loja';
    case 'calculator': return '/calculadora-frete';
    case 'subscription-plans': return '/planos';
    case 'support': return '/contato';
    case 'tracking': return '/rastreamento';
    case 'dashboard':
    case 'packages':
    case 'shipments':
      return '/painel';
    case 'admin-wordpress':
    case 'admin-packages':
    case 'admin-shipments':
    case 'admin-clients':
    case 'admin-finances':
      return '/admin';
    case 'info':
      return infoTopic ? getPathForTopic(infoTopic) : '/servicos-e-precos';
    case 'landing':
      return sectionId ? `/#${sectionId}` : '/';
    default:
      return '/';
  }
}

